module.exports = __webpack_public_path__ + "img/logo.875c9d66.svg";